<template>
	<div class="patient-statistics">
		<v-carousel v-model="carrousel" height="360" hide-delimiters>
			<v-carousel-item key="1">
				<v-sheet height="100%" tile color="white" class="black--text">
					<v-row class="fill-height" align="center" justify="center">
						<v-col cols="12" md="7">
							<b class="primary--text" v-translate>Clinic Data</b>
							<v-row no-gutters class="pt-5">
								<v-col cols="12" md="4" class="text-center">
									<v-progress-circular
										:rotate="360"
										:size="100"
										:width="15"
										:value="100"
										color="teal"
									>{{ nPatients }}</v-progress-circular>
									<p style="font-size: 12px" class="font-weight-bold mt-2" v-translate>Nº Patients</p>
								</v-col>
								<v-col cols="12" md="4" class="text-center">
									<v-progress-circular
										:rotate="360"
										:size="100"
										:width="15"
										:value="100"
										color="#0066ff"
									>{{ nAppointments }}</v-progress-circular>
									<p style="font-size: 12px" class="font-weight-bold mt-2" v-translate>Nº Appointments</p>
								</v-col>
								<v-col cols="12" md="4" class="text-center">
									<v-progress-circular
										:rotate="360"
										:size="100"
										:width="15"
										:value="100"
										color="#730099"
									>{{ average }}</v-progress-circular>
									<p
										style="font-size: 12px"
										class="font-weight-bold mt-2"
										v-translate
									>Average Appointments/Patient</p>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-sheet>
			</v-carousel-item>
			<v-carousel-item key="2">
				<v-sheet height="100%" tile color="white" class="black--text">
					<v-row class="fill-height" align="center" justify="center">
						<v-col cols="4">
							<b class="primary--text" v-translate>Statistics by Gender</b>
							<div id="chart">
								<VueApexCharts
									type="radialBar"
									height="330"
									:options="chartOptionsGender"
									:series="seriesGender"
								></VueApexCharts>
							</div>
						</v-col>
						<v-col cols="4">
							<b class="primary--text" v-translate>Statistics by Age Group</b>
							<div id="chart">
								<VueApexCharts height="330" type="radialBar" :options="chartOptionsAge" :series="seriesAge"></VueApexCharts>
							</div>
						</v-col>
					</v-row>
				</v-sheet>
			</v-carousel-item>
		</v-carousel>
	</div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
	name: "PatientStatistics",
	props: ["nPatients", "nAppointments", "average", "genderPercentages", "ageInfo"],
	components: {
		VueApexCharts
	},
	data: () => ({
		carrousel: 0,
		chartOptionsAge: {
			chart: {
				height: 390,
				type: "radialBar"
			},
			plotOptions: {
				radialBar: {
					offsetY: 0,
					startAngle: 0,
					endAngle: 270,
					hollow: {
						margin: 5,
						size: "30%",
						background: "transparent",
						image: undefined
					},
					dataLabels: {
						name: {
							show: false
						},
						value: {
							show: false
						}
					}
				}
			},
			colors: ["#009688", "#0066ff", "#730099", "#b30000"],
			labels: ["0-17", "18-39", "40-59", "60+"],
			legend: {
				show: true,
				floating: true,
				fontSize: "12px",
				position: "left",
				offsetX: 25,
				offsetY: 0,
				labels: {
					useSeriesColors: true
				},
				markers: {
					size: 0
				},
				formatter: function(seriesName, opts) {
					return (
						seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] + "%"
					);
				},
				itemMargin: {
					horizontal: 0
				}
			},
			responsive: [
				{
					breakpoint: 480,
					options: {
						legend: {
							show: true
						}
					}
				}
			]
		},
		chartOptionsGender: {
			chart: {
				height: 390,
				type: "radialBar"
			},
			plotOptions: {
				radialBar: {
					offsetY: -20,
					offsetX: -20,
					startAngle: 0,
					endAngle: 270,
					hollow: {
						margin: 5,
						size: "30%",
						background: "transparent",
						image: undefined
					},
					dataLabels: {
						name: {
							show: false
						},
						value: {
							show: false
						}
					}
				}
			},
			colors: ["#009688", "#0066ff"],
			labels: ["F", "M"],
			legend: {
				show: true,
				floating: true,
				fontSize: "12px",
				position: "left",
				offsetX: 0,
				offsetY: 0,
				labels: {
					useSeriesColors: true
				},
				markers: {
					size: 0
				},
				formatter: function(seriesName, opts) {
					return (
						seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] + "%"
					);
				},
				itemMargin: {
					horizontal: 3
				}
			},
			responsive: [
				{
					breakpoint: 480,
					options: {
						legend: {
							show: true
						}
					}
				}
			]
		}
	}),
	computed: {
		seriesGender() {
			return [this.genderPercentages.female, this.genderPercentages.male];
		},
		seriesAge() {
			return [
				this.ageInfo.age_1,
				this.ageInfo.age_2,
				this.ageInfo.age_3,
				this.ageInfo.age_4
			];
		}
	}
};
</script>